import { create } from "zustand";
import { persist } from "zustand/middleware";
import { Product } from "./cartStore";

interface WishlistStore {
  wishlist: Product[];
  addToWishlist: (product: Product) => void;
  removeFromWishlist: (productId: string) => void;
  toggleWishlist: (product: Product) => void;
  isInWishlist: (productId: string) => boolean;
  clearWishlist: () => void;
}

const useWishlistStore = create<WishlistStore>()(
  persist(
    (set, get) => ({
      wishlist: [],

      addToWishlist: (product: Product) => {
        set((state) => {
          const exists = state.wishlist.some((item) => item._id === product._id);
          if (exists) return state;
          
          return {
            wishlist: [...state.wishlist, product],
          };
        });
      },

      removeFromWishlist: (productId: string) => {
        set((state) => ({
          wishlist: state.wishlist.filter((item) => item._id !== productId),
        }));
      },

      toggleWishlist: (product: Product) => {
        const { wishlist, addToWishlist, removeFromWishlist } = get();
        const exists = wishlist.some((item) => item._id === product._id);
        
        if (exists) {
          removeFromWishlist(product._id);
        } else {
          addToWishlist(product);
        }
      },

      isInWishlist: (productId: string) => {
        return get().wishlist.some((item) => item._id === productId);
      },

      clearWishlist: () => set({ wishlist: [] }),
    }),
    {
      name: "wishlist-storage",
    },
  ),
);

export default useWishlistStore;
